// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.linkTag {
    color: rgb(255, 255, 255);
    font-weight: bold;
    text-decoration: none;
    margin-right: 15px;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.navbar-framed {
    background-color: #ffffff !important;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: 0;
}
.navbarContainer {
    width: 95vw;
}
.navLinksList {
    display: flex;
    align-items: center;
}
.navBrandWrapper {
    display: flex;
    align-items: center;
}
.App-logo {
    height: 55px;
    width: auto;
}
.navBrandText {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 12px;
}
.navBrandTitle {
    font-weight: 700;
    font-style: normal;
    font-size: 34.38px;
    line-height: normal;
    letter-spacing: 0px;
    color: #222222;
}
.navBrandSubtitle {
    font-weight: 500;
    font-style: normal;
    font-size: 14.73px;
    line-height: normal;
    letter-spacing: 0px;
    color: #222222;
    margin-top: 2px;
}
Nav .customNavLink{
    font-weight: 400;
    color: #172639;
    text-decoration: none;
}
Nav .customNavLink:hover,
Nav .customNavLink:focus {
    color: #EAA637;
}
.linkTagblack {
    color: rgb(0, 0, 0);
    font-weight: bold;
    text-decoration: none;
    margin-right: 15px;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.bg-body-tertiary {
    background-color: #006cfa !important ;
    border-bottom: 1px solid white;
}
.login-bg{
    background-color: red;
}

Nav .navLoginBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 134px;
    height: 48px;
    opacity: 1;
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    background: #F5B349;
    color: #ffffff;
    font-weight: 700;
}

Nav .navLoginBtn:hover {
    background: #172639;
    color: #ffffff;
}

@media only screen and (max-width: 991.98px) {
    .navbar-collapse {
        flex-basis: 100%;
        flex-grow: 1;
        background-color: #ffffff;
        border-top: 1px solid #f0f0f0;
        padding: 20px;
    }
    .navbar-nav a{
        margin-bottom: 10px;
    }
 }

@media only screen and (max-width: 576px) {
    .App-logo {
        height: 42px;
    }
    .navBrandTitle {
        font-size: 22px;
    }
    .navBrandSubtitle {
        font-size: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Navbar.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,oCAAoC;IACpC,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;AACjB;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;AACA;;IAEI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,qCAAqC;IACrC,8BAA8B;AAClC;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;QACZ,yBAAyB;QACzB,6BAA6B;QAC7B,aAAa;IACjB;IACA;QACI,mBAAmB;IACvB;CACH;;AAED;IACI;QACI,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".linkTag {\n    color: rgb(255, 255, 255);\n    font-weight: bold;\n    text-decoration: none;\n    margin-right: 15px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n.navbar-framed {\n    background-color: #ffffff !important;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    margin-top: 0;\n}\n.navbarContainer {\n    width: 95vw;\n}\n.navLinksList {\n    display: flex;\n    align-items: center;\n}\n.navBrandWrapper {\n    display: flex;\n    align-items: center;\n}\n.App-logo {\n    height: 55px;\n    width: auto;\n}\n.navBrandText {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin-left: 12px;\n}\n.navBrandTitle {\n    font-weight: 700;\n    font-style: normal;\n    font-size: 34.38px;\n    line-height: normal;\n    letter-spacing: 0px;\n    color: #222222;\n}\n.navBrandSubtitle {\n    font-weight: 500;\n    font-style: normal;\n    font-size: 14.73px;\n    line-height: normal;\n    letter-spacing: 0px;\n    color: #222222;\n    margin-top: 2px;\n}\nNav .customNavLink{\n    font-weight: 400;\n    color: #172639;\n    text-decoration: none;\n}\nNav .customNavLink:hover,\nNav .customNavLink:focus {\n    color: #EAA637;\n}\n.linkTagblack {\n    color: rgb(0, 0, 0);\n    font-weight: bold;\n    text-decoration: none;\n    margin-right: 15px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n.bg-body-tertiary {\n    background-color: #006cfa !important ;\n    border-bottom: 1px solid white;\n}\n.login-bg{\n    background-color: red;\n}\n\nNav .navLoginBtn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 134px;\n    height: 48px;\n    opacity: 1;\n    padding: 8px 16px;\n    border: none;\n    border-radius: 4px;\n    background: #F5B349;\n    color: #ffffff;\n    font-weight: 700;\n}\n\nNav .navLoginBtn:hover {\n    background: #172639;\n    color: #ffffff;\n}\n\n@media only screen and (max-width: 991.98px) {\n    .navbar-collapse {\n        flex-basis: 100%;\n        flex-grow: 1;\n        background-color: #ffffff;\n        border-top: 1px solid #f0f0f0;\n        padding: 20px;\n    }\n    .navbar-nav a{\n        margin-bottom: 10px;\n    }\n }\n\n@media only screen and (max-width: 576px) {\n    .App-logo {\n        height: 42px;\n    }\n    .navBrandTitle {\n        font-size: 22px;\n    }\n    .navBrandSubtitle {\n        font-size: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
